import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DriverCommercialIntentViewModel } from '../../../driver/models/driver-commercial-intent-view.model';
import { MvdModalService } from '../../../shared/services/modal/mvd-modal.service';

export class DriverCommercialIntentHistoryModalContext {
    constructor(
        public driverCommercialIntentHistory: DriverCommercialIntentViewModel[] = []
    ) {
    }
}

@Component({
    templateUrl: './driver-commercial-intent-history-modal.component.html'
})
export class DriverCommercialIntentHistoryModalComponent {
    /**
     * The driver commercial intent history.
     */
    public driverCommercialIntentHistory: DriverCommercialIntentViewModel[] = [];

    constructor(
        public dialogRef: MatDialogRef<DriverCommercialIntentHistoryModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public context: DriverCommercialIntentHistoryModalContext,
        public modalService: MvdModalService
    ) {
        this.driverCommercialIntentHistory = this.context.driverCommercialIntentHistory;
    }

    /**
     * Handles the cancel action on the modal.
     */
    public cancel(): void {
        this.dialogRef.close();
    }
}
